import "./UseAnywhere.css";

import PartiesImg from "../assets/Angle3.png";

const EducationImg = "/SchoolHouseFinal.png";
const BusinessImg = "/Anywhere.png";
const RemoteImg = "/WatchVideosAnywhere.png";

const useCases = [
  {
    eyebrow: "Education",
    title: "Turn remote schoolhouses into connected EdTech hubs",
    body: `ChipServer makes it practical to drop a full digital classroom into communities that never had dependable connectivity.`,
    highlights: [
      "Preload STEM labs, literacy apps, and curriculum videos and share them across every device without touching the public internet.",
      "Teachers sync lesson plans once, then replay them offline all week for students trekking in from satellite campuses.",
      "Learners connect with low-cost tablets or phones and still enjoy modern, media-rich content with no buffering.",
    ],
    image: EducationImg,
    alt: "Students using ChipServer in a remote classroom",
  },
  {
    eyebrow: "Business",
    title: "Secure, offline file sharing for teams on the move",
    body: `Keep sensitive projects moving even when you are air-gapped, in a war room, or on a factory floor with strict RF policies.`,
    highlights: [
      "Hand-carry proposals, CAD files, and compliance binders, then share them via encrypted local Wi-Fi—no cloud exposure.",
      "Issue temporary access codes for partners or clients, revoke them instantly, and leave with a clean audit trail.",
      "Mirror shared drives so field teams can collaborate on the latest version even when HQ is thousands of miles away.",
    ],
    image: BusinessImg,
    alt: "Secure business collaboration around ChipServer",
  },
  {
    eyebrow: "Remote regions",
    title: "Share everywhere the internet isn’t",
    body: `Deploy ChipServer in the backcountry, at sea, or anywhere infrastructure stops. It becomes the pocket-sized intranet for every mission.`,
    highlights: [
      "Spin up a pop-up network in the park or on a plane so guides, crew, or passengers can review manifests and safety briefings.",
      "Let families show kids movies in the car, read e-books, or play multiplayer games on epic road trips without burning cell data.",
      "Cache telehealth instructions, field research data, or disaster response handbooks for clinics and teams days away from a tower.",
    ],
    image: RemoteImg,
    alt: "ChipServer powering media in remote regions",
  },
  {
    eyebrow: "Parties & pop-ups",
    title: "Power every celebration without relying on venue Wi-Fi",
    body: `ChipServer keeps the entertainment flowing no matter how crowded the venue gets.`,
    highlights: [
      "Mirror photo slideshows to every television or projector in sync for receptions and reunions.",
      "Hand guests karaoke lyrics, playlists, and trivia scoreboards directly on their phones so they can read and sing without stage delays.",
      "Share vendor menus, AR scavenger hunts, highlight reels, or live polling dashboards instantly when inspiration hits.",
    ],
    image: PartiesImg,
    alt: "Party guests using ChipServer content",
  },
];

export default function UseAnywhere() {
  return (
    <section id="use-anywhere" className="use-anywhere-section">
      <div className="use-anywhere-wrapper">
        <div className="use-anywhere-header">
          <p className="eyebrow">Use Anywhere</p>
          <h2>Where will you take ChipServer next?</h2>
          <p>
            From classrooms in the high desert to rooftop launch parties, ChipServer delivers the
            same fast, private, and offline-first experience. Explore how teams are already using
            it in the field.
          </p>
        </div>

        <div className="use-anywhere-grid">
          {useCases.map((useCase, index) => (
            <article
              key={useCase.title}
              className={`use-anywhere-row ${index % 2 === 1 ? "reverse" : ""}`}
            >
              <div className="use-anywhere-media">
                <img src={useCase.image} alt={useCase.alt} loading="lazy" />
              </div>

              <div className="use-anywhere-content">
                <p className="eyebrow">{useCase.eyebrow}</p>
                <h3>{useCase.title}</h3>
                <p className="use-anywhere-body">{useCase.body}</p>
                <ul>
                  {useCase.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

